export default {
  'imm5406.familyMemberTableTitle': '家庭成員',
  'imm5406.familyMemberTableFullName': '姓名',
  'imm5406.familyMemberTableStatus': '狀態',
  'imm5406.familyMemberTableStatus.missingInformation': '缺少信息',
  'imm5406.familyMemberTableStatus.complete': '完成',

  'imm5406.title.applicant': '申請人',
  'imm5406.title.partner': '配偶、同居伴侶或事實婚姻伴侶（如果適用）',
  'imm5406.title.mother': '母親',
  'imm5406.title.father': '父親',
  'imm5406.title.child': '子女',
  'imm5406.title.siblings': '兄弟姊妹',
  'imm5406.title.formList.child': '子女 #',
  'imm5406.title.formList.siblings': '兄弟姊妹 #',

  'imm5406.description.sibling': '包括同父異母、同母異父和繼兄妹。',
  'imm5406.description.maritalStatus.marriedPhysicallyPresent':
    '如果您已婚且您的配偶親自出席了婚禮，請在“婚姻狀況”下選擇“已婚 - 親自出席”',
  'imm5406.description.maritalStatus.marriedNotPhysicallyPresent':
    '如果您已婚但您的配偶沒有親自出席婚禮，請在“婚姻狀況”下選擇“已婚 - 未親自出席”',

  'imm5406.fullName': '姓名',
  'imm5406.dateOfBirth': '出生日期（年/月/日）',
  'imm5406.countryOfBirth': '出生國家或地區',
  'imm5406.applicantMaritalStatus':
    '婚姻狀況（例如已婚 - 親自出席、已婚 - 未親自出席、同居伴侶、單身、離婚、喪偶、分居）',
  'imm5406.partnerMaritalStatus':
    '婚姻狀況（例如已婚 - 親自出席、已婚 - 未親自出席、同居伴侶、離婚、喪偶、分居、不適用 - 已故）',
  'imm5406.otherDependantMaritalStatus':
    '婚姻狀況（例如已婚、同居伴侶、單身、離婚、喪偶、分居、不適用 - 已故）',
  'imm5406.emailAddress': '電子郵件地址',
  'imm5406.address': '提供地址。给出城市/城鎮和国家或地區（最多80個字符）：',
  'imm5406.deceasedAddress':
    '提供地址。如果已故，請提供城市/城鎮、國家或地區和日期（最多80個字符）：',
  'imm5406.relationship': '關係',

  'imm5406.steps.sectionA': 'A部分',
  'imm5406.steps.sectionB': 'B部分 - 子女',
  'imm5406.steps.sectionC': 'C部分 - 兄弟姊妹',
};
